"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M21 2a12.986 12.986 0 0 0-10.578 20.538L.662 32.3a2.066 2.066 0 0 0 .106 2.934 2.066 2.066 0 0 0 2.934.105l9.76-9.76A13 13 0 1 0 21 2zm0 22a9 9 0 1 1 9-9 9 9 0 0 1-9 9z" })
);

